import type { QueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { startExtensionBridge } from "@/lib/extension-bridge";

/**
 * Mounts the browser-extension postMessage bridge (see lib/extension-bridge).
 * Rendered once inside AuthProvider so bridge actions always run on the
 * signed-in admin's API client.
 */
export function ExtensionBridge({ queryClient }: { queryClient: QueryClient }) {
  useEffect(() => startExtensionBridge(queryClient), [queryClient]);
  return null;
}
